import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-product-rating',
  templateUrl: './product-rating.component.html',
  styleUrls: ['./product-rating.component.css']
})
export class ProductRatingComponent implements OnInit {
  @Input() maxRating: number = 5;
  @Input() rating: number = 0;
  @Output() ratingClick: EventEmitter<number> = new EventEmitter<number>();

  stars: boolean[] = [];
  constructor() { }

  ngOnInit(): void {
    this.setStars();    
  }

  rate(rating: number) {
    console.log('-------rating',rating)
    this.rating = rating;
    this.ratingClick.emit(rating);
    this.setStars();
  }
  convertToWholeNumber(value: number): number {
    if (value % 1 !== 0) {
      console.log('rating',Math.floor(Number(value)))
      return Math.floor(Number(value))
    } else {
      return value - 0.5;
    }
    
  }
  setStars() {
    this.stars = Array(this.maxRating).fill(false);
    const fullStars = Math.floor(this.rating);
    const hasHalfStar = this.rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      this.stars[i] = true;
    }

    if (hasHalfStar) {
      this.stars[fullStars] = true;
    }
    //console.log(this.stars)
  }


}
